const INPUT_LIMIT = {
  inputMaxLength: 700,
  prologueMaxLength: 255,
};
// 应用列表，角色 的 type
const CHARACTER_TYPE = "personify";

const CHAT_MODEL_ID = "personify";

const REWRITE_TYPE = "rewrite";

const CONTENT_COMPLETION_TYPE = "contentCompletion";

const NOVEL_WRITE = "novelWrite";

const CONTENT_WRITE = "contentWrite";

export {
  INPUT_LIMIT,
  CHARACTER_TYPE,
  CHAT_MODEL_ID,
  REWRITE_TYPE,
  CONTENT_COMPLETION_TYPE,
  NOVEL_WRITE,
  CONTENT_WRITE,
};
